export { default as Info } from './Info';
